import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.string.anchor.js";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useState, useEffect } from "react";
import { Icon, Typography, RaiseColors, makeStyles, useTheme } from "componentLibrary";
import { useAlert } from "./AlertProvider";
import { IconConstants } from "componentLibrary/MuiComponentWrappers/Icon/IconConstants";
import useWindowSize from "hooks/useWindowSize";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var idCounter = 0;
var useStyles = makeStyles(function () {
  return {
    anchor: {
      position: "relative",
      width: "100%"
    },
    container: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      gap: "8px",
      borderRadius: "8px",
      position: "absolute",
      zIndex: 2,
      // Add smooth transitions
      transition: "all 0.3s ease-in-out",
      opacity: 1,
      transform: "translateY(0)",
      "&.entering": {
        opacity: 0,
        transform: "translateY(-20px)"
      },
      "&.exiting": {
        opacity: 0,
        transform: "translateY(-20px)"
      },
      "&.visible": {
        opacity: 1,
        transform: "translateY(0)"
      }
    },
    iconText: {
      display: "flex",
      alignItems: "flex-start",
      gap: 8
    }
  };
});
var alertTypeStyles = {
  primary: {
    backgroundColor: RaiseColors.science200,
    borderColor: RaiseColors.science900,
    color: RaiseColors.science1500
  },
  success: {
    backgroundColor: RaiseColors.watercourse200,
    borderColor: RaiseColors.watercourse900,
    color: RaiseColors.watercourse1500,
    defaultIcon: IconConstants.CIRCLE_CHECK
  },
  warning: {
    backgroundColor: RaiseColors.amber200,
    borderColor: RaiseColors.amber900,
    color: RaiseColors.amber1500
  },
  error: {
    backgroundColor: RaiseColors.destructive100,
    borderColor: RaiseColors.destructive500,
    color: RaiseColors.destructive500
  }
};
var Alert = function Alert(_ref) {
  var _useWindowSize$innerW;
  var containerStyle = _ref.containerStyle,
    leadingIcon = _ref.leadingIcon,
    message = _ref.message,
    type = _ref.type,
    onClose = _ref.onClose,
    _ref$isRelativePositi = _ref.isRelativePosition,
    isRelativePosition = _ref$isRelativePositi === void 0 ? false : _ref$isRelativePositi;
  var classes = useStyles();
  var alertStyle = alertTypeStyles[type];
  var defaultIcon = leadingIcon || alertStyle.defaultIcon;
  var windowSize = (_useWindowSize$innerW = useWindowSize().innerWidth) !== null && _useWindowSize$innerW !== void 0 ? _useWindowSize$innerW : 0;
  var theme = useTheme();
  var isMobile = windowSize < _valuesInstanceProperty(theme.breakpoints).lg;
  return /*#__PURE__*/_jsx("div", {
    className: classes.anchor,
    children: /*#__PURE__*/_jsxs("div", {
      className: classes.container,
      style: _objectSpread(_objectSpread({
        backgroundColor: alertStyle.backgroundColor,
        border: "1px solid ".concat(alertStyle.borderColor),
        padding: isMobile ? "12px 16px" : "12px 24px"
      }, containerStyle), isRelativePosition ? {
        position: "relative"
      } : {}),
      children: [/*#__PURE__*/_jsxs("div", {
        className: classes.iconText,
        children: [defaultIcon && /*#__PURE__*/_jsx(Icon, {
          className: defaultIcon,
          color: alertStyle.color,
          fontSize: 20
        }), /*#__PURE__*/_jsx(Typography, {
          color: alertStyle.color,
          variant: "paragraph_small",
          children: message
        })]
      }), onClose && /*#__PURE__*/_jsx(Icon, {
        className: IconConstants.X,
        color: alertStyle.color,
        fontSize: 20,
        onClick: onClose
      })]
    })
  });
};
var DisappearingAlert = function DisappearingAlert(_ref2) {
  var _useWindowSize$innerW2, _context;
  var containerStyle = _ref2.containerStyle;
  var _useAlert = useAlert(),
    getCurrentAlert = _useAlert.getCurrentAlert,
    hideAlert = _useAlert.hideAlert,
    registerAlertComponent = _useAlert.registerAlertComponent,
    unregisterAlertComponent = _useAlert.unregisterAlertComponent;
  var _useState = useState(function () {
      return "alert-".concat(++idCounter);
    }),
    _useState2 = _slicedToArray(_useState, 1),
    componentId = _useState2[0];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isVisible = _useState4[0],
    setIsVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isExiting = _useState6[0],
    setIsExiting = _useState6[1];
  var classes = useStyles();
  var windowSize = (_useWindowSize$innerW2 = useWindowSize().innerWidth) !== null && _useWindowSize$innerW2 !== void 0 ? _useWindowSize$innerW2 : 0;
  var theme = useTheme();
  var isMobile = windowSize < _valuesInstanceProperty(theme.breakpoints).lg;
  useEffect(function () {
    registerAlertComponent(componentId);
    return function () {
      return unregisterAlertComponent(componentId);
    };
  }, [componentId, registerAlertComponent, unregisterAlertComponent]);
  var alert = getCurrentAlert(componentId);
  useEffect(function () {
    if (alert && !isVisible) {
      setIsVisible(true);
      setIsExiting(false);
    } else if (!alert && isVisible) {
      setIsExiting(true);
      var timer = _setTimeout(function () {
        setIsVisible(false);
        setIsExiting(false);
      }, 300);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [alert, isVisible]);
  if (!alert && !isVisible) return null;
  var alertStyles = alertTypeStyles[(alert === null || alert === void 0 ? void 0 : alert.type) || "primary"];
  return /*#__PURE__*/_jsx("div", {
    className: classes.anchor,
    children: /*#__PURE__*/_jsxs("div", {
      className: _concatInstanceProperty(_context = "".concat(classes.container, " ")).call(_context, isExiting ? "exiting" : isVisible ? "visible" : "entering"),
      style: _objectSpread({
        backgroundColor: alertStyles.backgroundColor,
        border: "1px solid ".concat(alertStyles.borderColor),
        padding: isMobile ? "12px 16px" : "12px 24px"
      }, containerStyle),
      children: [/*#__PURE__*/_jsxs("div", {
        className: classes.iconText,
        children: [alert && (alert.leadingIcon || alertStyles.defaultIcon) && /*#__PURE__*/_jsx(Icon, {
          className: alert.leadingIcon || alertStyles.defaultIcon,
          color: alertStyles.color,
          fontSize: 20
        }), /*#__PURE__*/_jsx(Typography, {
          color: alertStyles.color,
          variant: "paragraph_small",
          children: alert === null || alert === void 0 ? void 0 : alert.message
        })]
      }), alert ? /*#__PURE__*/_jsx(Icon, {
        className: IconConstants.X,
        color: alertStyles.color,
        fontSize: 20,
        onClick: hideAlert
      }) : null]
    })
  });
};
export var StaticAlert = function StaticAlert(_ref3) {
  var message = _ref3.message,
    type = _ref3.type,
    leadingIcon = _ref3.leadingIcon,
    _ref3$isRelativePosit = _ref3.isRelativePosition,
    isRelativePosition = _ref3$isRelativePosit === void 0 ? false : _ref3$isRelativePosit;
  return /*#__PURE__*/_jsx(Alert, {
    message: message,
    type: type,
    leadingIcon: leadingIcon,
    isRelativePosition: isRelativePosition
  });
};
export default DisappearingAlert;